<div class="card mb-3" [class.card-drag]="!selectionMode">
  <div class="card-header d-flex justify-content-between">
    <div class="d-flex align-items w-100">
      <div class="icon">
        <img *ngIf="fblogo" [src]="fblogo">
      </div>

      <label class="page-name p-2" style="margin-top: 1px">{{token.token.pageTitle}}</label>
    </div>

    <div *ngIf="!selectionMode" class="d-flex ">
      <div class="d-flex align-items-center">
        <div *ngIf="token.token.authFailure === true" class="badge badge-short text-bg-danger">Failed</div>
        <div *ngIf="token.locationToken.enabled === false" class="badge badge-short text-bg-secondary">Disabled</div>
      </div>

      <div ngbDropdown placement="bottom-right" (openChange)="menuStateChange()">
        <button class="btn btn-icon btn-icon-only btn-borderless" style="margin-top: 4px" ngbDropdownToggle>
          ⋮
        </button>

        <div ngbDropdownMenu style="padding: 0px">
          <button type="button" tabindex="0" class="dropdown-option button-opt clickable" (click)="toggle.emit()">
            <span>{{ token.locationToken.enabled ? "Disable" : "Enable" }}</span>
          </button>

          <button type="button" tabindex="0" class="dropdown-option button-opt clickable critical" style="cursor: pointer" (click)="delete.emit()">
            <span>Remove</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex card-footer px-3" style="border-bottom-width: 0">
    <div>
      <a [href]="pageUrl()" target="_blank">{{ pageUrl() }}</a>
    </div>
  </div>
</div>
